import RecordBase from './../tools/RecordBase';

class MailTemplate extends RecordBase {

  constructor () {
    super();
    this.state.cls = 'mailtemplates';
    this.state.record = {
      MailFrom: '',
      Subject: '',
      Body: '',
    }
  }

  componentDidMount ()  {
    super.componentDidMount();
  }

  handleQuillChange = (value, event) => {
    let record = this.state.record;
    record.Body = value;
    this.setState({
      record: record
    });
  }

}

export default MailTemplate;
